import { Suspense } from 'react';
import MonteCarloForm from './MonteCarloForm';
import { useLoaderData, Await } from 'react-router';
import { getMonteCarloNodes } from '@/utils/pathwayUtils';
import { nodesActions } from '@/stores/nodesStore';

const MonteCarloSettings = () => {
  const { data } = useLoaderData();

  return (
    <Suspense fallback={<div className="p-4">Loading please wait...</div>}>
      <Await resolve={data} errorElement={<div className="p-4 text-red-500">Failed to load Monte Carlo settings.</div>}>
        {data => {
          const [
            {
              data: { nodes },
            },
            { data: caseNodes },
          ] = data;
          const { filteredNodes, filteredCaseNodes } = getMonteCarloNodes(nodes, caseNodes);

          nodesActions.init(filteredCaseNodes, nodes);
          return <MonteCarloForm data={{ nodes: filteredNodes, caseNodes: filteredCaseNodes }} />;
        }}
      </Await>
    </Suspense>
  );
};

export default MonteCarloSettings;
